<template>
    <div class="container free-shipping-container" if="free_shipping_day?.result">
        <div class="row">
            <div class="col-12">
                <div class="card shadow-sm">
                    <div class="d-flex justify-content-center card-header bg-primary text-white">
                        <a href="/products-cards-bra-center">
                            <h5 class="mb-0">
                                <strong> Frete grátis* </strong>
                                <strong>{{ free_shipping_day.dayOfWeek }}</strong>,
                                <strong>{{ free_shipping_day.result }}</strong>
                            </h5>
                        </a>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
        };
    },
    mounted() {
    },
    methods: {

    },
    computed: {
        free_shipping_day() {
            return this.$store.state.product.free_shipping_day;
        }
    },
    beforeCreate() {
        this.$store.dispatch("product/get_free_shipping_day");
    }
};
</script>

<style scoped>
.card {
    border-radius: 8px;
}

.card-header {
    border-bottom: none;
}

.card-title {
    font-weight: 500;
}

.btn-outline-primary {
    border: 2px solid #007bff;
    color: #007bff;
}

.btn-outline-primary:hover {
    background-color: #007bff;
    color: white;
}

#widthButton {
    max-width: 100%;
}

@media (max-width: 768px) {
    .free-shipping-container {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 10;
        box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    }
}
</style>